import React from 'react';

import { BetSummaryProps, BetSummarySection, BetSummarySectionProps } from '@/components/BetSummarySection';
import { usePotentialPayout } from '@/feature/bets-sbk/hooks/use-potential-payout';
import { getMultiplier } from '@/feature/bets-sbk/utils/bet-summary-section-utils';
import { isVoidedResult } from '@/feature/bets-sbk/utils/is-voided-result';
import { useFormatCurrency } from '@/hooks/use-format-currency';

import { useBetDetailsVoidedBetSummary, useSettledPayoutSummary, useSharedBetDetailsBetSummary } from './utils';

/**
 * Helper Hooks
 */
const useOpenMultiBetSummary = (props: BetSummaryProps): BetSummarySectionProps => {
    const { bet } = props;
    const { formatCurrency } = useFormatCurrency();
    const payout = usePotentialPayout(bet);
    return {
        ...useSharedBetDetailsBetSummary(props),
        ...getMultiplier(bet),
        body3Text: formatCurrency(payout),
        ...props.betSummarySectionProps,
    };
};

const useSettledMultiBetSummary = (props: BetSummaryProps): BetSummarySectionProps => ({
    ...useSharedBetDetailsBetSummary(props),
    ...getMultiplier(props.bet),
    ...useSettledPayoutSummary(props.bet),
    ...props.betSummarySectionProps,
});

/**
 * Components
 */
const OpenMultiBetSummary = (props: BetSummaryProps) => <BetSummarySection {...useOpenMultiBetSummary(props)} />;

const VoidedMultiBetSummary = (props: BetSummaryProps) => (
    <BetSummarySection {...useBetDetailsVoidedBetSummary(props)} />
);

const SettledMultiBetSummary = (props: BetSummaryProps) => <BetSummarySection {...useSettledMultiBetSummary(props)} />;

// Handles both Script and Combo bet types
export const MultiBetSummarySection = (props: BetSummaryProps) => {
    const { bet } = props;
    if (isVoidedResult(bet.result)) {
        return <VoidedMultiBetSummary {...props} />;
    }
    switch (bet.result) {
        case 'WON':
        case 'LOST':
        case 'CASHEDOUT':
            return <SettledMultiBetSummary {...props} />;
        default:
            return <OpenMultiBetSummary {...props} />;
    }
};
